import request from '@/plugins/axios';

//POST
// /_product_/article/createArticle
// 发布图文文章
export function createArticle(data) {
    return request[0]({
        url: '/_product_/article/createArticle',
        method: 'post',
        data
    })
}

//POST
// /_product_/article/deleteArticle
// 删除图文文章
export function deleteArticle(params) {
    return request[0]({
        url: '/_product_/article/deleteArticle',
        method: 'post',
        params
    })
}

//GET
// /_product_/article/getInfo
// 查看图文文章详情
export function getArticleInfo(params) {
    return request[0]({
        url: '/_product_/article/getInfo',
        method: 'get',
        params
    })
}

//GET
// /_product_/article/list
// 图文文章列表
export function getArticleList(params) {
    return request[0]({
        url: '/_product_/article/list',
        method: 'get',
        params
    })
}

//POST
// /_product_/article/updateArticle
// 修改图文文章
export function updateArticle(data) {
    return request[0]({
        url: '/_product_/article/updateArticle',
        method: 'post',
        data
    })
}

//GET
// /_product_/loginSubscribe/getInfo
// 登录用户根据订阅管理员编号查看订阅号信息
export function getSubsInfo() {
    return request[0]({
        url: '/_product_/loginSubscribe/getInfo',
        method: 'get',
    })
}

export function transcoding(data) {
    return request[0]({
        url: '/fileOpen/transcoding',
        method: 'post',
        params:data
    })
}